import { Box, Grid, Grow } from "@mui/material";
import Meta from "../../../../components/common/Meta";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useSound } from "../../../../context/juno/SoundContext";
import SoundModelSelector from "./components/SoundModelSelector";
import SoundParams from "./components/SoundParams";
import SoundLibrary from "./components/SoundLibrary";
import InputPrompt from "./components/InputPrompt";
import { uiHeight } from "../../../../utils/uiHeight";

const MusicGenerator = () => {
  const { t } = useTranslation();
  const { aiEngine } = useSound();
  // 生成完了を通知するためのstate
  const [generationCompleted, setGenerationCompleted] = useState(false);

  return (
    <>
      <Meta title={t("juno.sound.title")} meta={[{ name: "robots", content: "noindex, nofollow" }]} />
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column", mt: 1 }}>
        <Box sx={{ mx: 2 }}>
          <Grid container spacing={2} sx={{ height: uiHeight(-240) }}>
            <Grid
              sx={{ transition: "all 0.3s ease", display: "flex", flexDirection: "column", height: "100%" }}
              size={{ xs: 12, md: 3 }}
            >
              <Grow in={true} timeout={500}>
                <Box sx={{ flexShrink: 0 }}>
                  <SoundModelSelector />
                </Box>
              </Grow>

              {aiEngine && (
                <Grow in={true} timeout={500}>
                  <Box sx={{ flexGrow: 1, minHeight: 0, width: "100%" }}>
                    <SoundParams
                      generationCompleted={generationCompleted}
                      setGenerationCompleted={setGenerationCompleted}
                    />
                  </Box>
                </Grow>
              )}
            </Grid>
            {/* 右カラムを Flexbox コンテナにする */}
            <Grid
              sx={{ transition: "all 0.3s ease", display: "flex", flexDirection: "column", height: "100%" }}
              size={{ xs: 12, md: 9 }}
            >
              {aiEngine && (
                <Grow in={true} timeout={500}>
                  <Box sx={{ flexShrink: 0 }}>
                    <InputPrompt setGenerationCompleted={setGenerationCompleted} />{" "}
                  </Box>
                </Grow>
              )}
              <Grow in={true} timeout={500}>
                <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                  <SoundLibrary generationCompleted={generationCompleted} />
                </Box>
              </Grow>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default MusicGenerator;
